/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : PRODUCT MANAGER: SITE SETUP : ADDITIONAL : STYLES --------------- ++++++++++ */
export default theme => ({
  additional: {
    '& .icon': {
      color: '#7E92B8'
    },
    '& > .content': { rowGap: pxToEm(2)},
    '& .commentscountercode': {
      '&.enabled-false': {
        opacity: 0.4,
        pointerEvents: 'none'
      }
    }
  }
});
